export const STEP_CONFIGURATION_QUERY = `
  MULTI_VEHICLE_TRANSFER {
    id
    scope
    steps {
      vehicleMainInfo { isRequired isVisible }
      equipmentVerification { isRequired isVisible }
      tireInformation { isRequired isVisible }
      vehiclePhotos { isRequired isVisible }
      vehicleFiles { isRequired isVisible }
      damagesManagement { isRequired isVisible }
    }
  }
  REVENUE_MOVEMENT {
    id
    scope
    steps {
      vehicleMainInfo { isRequired isVisible }
      equipmentVerification { isRequired isVisible }
      vehiclePhotos { isRequired isVisible }
      damagesManagement { isRequired isVisible }
    }
  }
  NON_REVENUE_MOVEMENT {
    id
    scope
    steps {
      vehicleMainInfo { isRequired isVisible }
      equipmentVerification { isRequired isVisible }
      vehiclePhotos { isRequired isVisible }
      damagesManagement { isRequired isVisible }
    }
  }
`;
